/**
 * Dashboard Type Definitions
 */

/**
 * Date range options for filtering dashboard data
 */
export type DateRange = 'day' | 'week' | 'ytd' | '1year' | '3years' | 'max';

export const DATE_RANGE_OPTIONS: { value: DateRange; label: string }[] = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'ytd', label: 'YTD' },
  { value: '1year', label: '1 Year' },
  { value: '3years', label: '3 Years' },
  { value: 'max', label: 'Max' },
];

/**
 * Calculate the start date for a given date range
 * Returns null for 'max' (no filtering)
 */
export const getDateRangeStart = (range: DateRange): Date | null => {
  const now = new Date();

  switch (range) {
    case 'day':
      return new Date(now.getTime() - 24 * 60 * 60 * 1000);
    case 'week':
      return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    case 'ytd': {
      const startOfYear = new Date(now.getFullYear(), 0, 1);
      return startOfYear;
    }
    case '1year':
      return new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
    case '3years':
      return new Date(now.getTime() - 3 * 365 * 24 * 60 * 60 * 1000);
    case 'max':
    default:
      return null; // No filtering
  }
};

export interface DashboardStats {
  totalRevenue: string;
  revenueChange: string;
  activeDeals: number;
  activeDealsChange: string;
  pendingProposals: number;
  pendingProposalsNote: string;
  instagramFollowerGrowth: string;
  instagramFollowerGrowthChange: string;
  facebookFollowerGrowth: string;
  facebookFollowerGrowthChange: string;
  xFollowerGrowth: string;
  xFollowerGrowthChange: string;
  brandsCount: number;
}

export interface DealStatusData {
  pitching: number;
  negotiating: number;
  contractSigned: number;
  contentInProgress: number;
  awaitingPayment: number;
  completed: number;
  total: number;
}

export interface RevenueForecastData {
  amount: string;
  change: string;
  period: 'Month' | 'Quarter' | 'Year';
}

export interface DeadlineItem {
  id: string;
  brandName: string;
  brandLogo: string;
  description: string;
  daysLeft: number;
  date: string;
  status: 'urgent' | 'normal' | 'overdue';
}

export interface ActivityItem {
  id: string;
  type: 'payment' | 'view' | 'deadline' | 'message' | 'completion';
  icon: string;
  iconColor: string;
  message: string;
  brandName?: string;
  timestamp: string;
}

export type DeadlineTab = 'content' | 'invoices' | 'proposals';
export type ActivityTab = 'activity' | 'chat';
